import { render, staticRenderFns } from "./first-upcoming-action-document.vue?vue&type=template&id=13937a19"
import script from "./first-upcoming-action-document.vue?vue&type=script&lang=js"
export * from "./first-upcoming-action-document.vue?vue&type=script&lang=js"
import style0 from "./first-upcoming-action-document.vue?vue&type=style&index=0&id=13937a19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports